import { AVIS_INICIALITZAR, AVIS_VISUALITZACIO_ACTUALITZAR_IDS_AVISOS_DEL_MAPA } from '../../../../actions/actionTypes';

const ESTAT_INICIAL_IDS_FILTRATS_PEL_MAPA = [];

const idsFiltratsPelMapa = (state = ESTAT_INICIAL_IDS_FILTRATS_PEL_MAPA, action) => {
    switch (action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL_IDS_FILTRATS_PEL_MAPA;

        case AVIS_VISUALITZACIO_ACTUALITZAR_IDS_AVISOS_DEL_MAPA:
            return action.idsFiltratsPelMapa;

        default:
            return state;
    }
};

export default idsFiltratsPelMapa;



// WEBPACK FOOTER //
// ./src/reducers/avis/visualitzacio/avisos/idsFiltratsPelMapa.js